import React from 'react';
import { FormikProps } from 'formik';
import ATMLoadingButton from 'src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton';
import ATMTextField from 'src/components/UI/atoms/formFields/ATMTextField/ATMTextField';
import { AttemptFormValues } from 'src/models/Attempt.model';

type Props = {
    formikProps: FormikProps<AttemptFormValues>;
    onClose: () => void;
    formType: string
};

const AttemptForm = ({ formikProps, onClose, formType }: Props) => {
    const { values, setFieldValue, isSubmitting, handleBlur } = formikProps;

    return (
        <div className='p-4 flex flex-col gap-6'>
            <div className='flex justify-between items-center'>
                <div className='text-xl font-medium'>
                    {formType === "ADD" ? "Add Attempt" : "Update Attempt"}{" "}
                </div>
                <button type='button' className='hover:bg-hover' onClick={onClose}>
                    Cancel
                </button>
            </div>
            <div className='flex flex-col gap-4'>
                <div>
                    <ATMTextField
                        name='attempt'
                        required
                        value={values.attempt}
                        onChange={(e) => {
                            setFieldValue('attempt', e.target.value);
                        }}
                        label='Attempt'
                        onBlur={handleBlur}
                    />
                </div>
            </div>
            <div>
                <ATMLoadingButton isLoading={isSubmitting} type='submit'>
                    Save
                </ATMLoadingButton>
            </div>
        </div>
    );
};

export default AttemptForm;